<template>
  <div>
    <el-form-item
      ref="formItem"
      :class="{ elitem: $attrs.width && $attrs.width == 'full' }"
      :label-width="$attrs['label-width']"
      :prop="$attrs['prop']"
      :label="$attrs['label']"
      :style="$attrs['style']"
    >
      <el-row :gutter="0">
        <el-col :span="!single ? 8 : 24" class="col_positon">
          <!-- <el-input
            v-model="code"
            class="left_input"
            :class="{ leftInput: single }"
            :disabled="more || disable"
            v-bind="$attrs"
            @input="(value) => setModel(value)"
          /> -->
          <el-input
            v-model="code"
            class="left_input"
            :class="{ leftInput: single }"
            :disabled="more || disable"
          />
          <div class="more_box flex_center flex_center_align" @click="openMode">
            <div v-if="more" class="inner_box flex_center flex_center_align">
              <svg-icon :icon-class="'sel'"></svg-icon>
            </div>
            <svg-icon v-else icon-class="select"></svg-icon>
          </div>
        </el-col>
        <el-col v-if="!single" :span="16">
          <vab-select
            v-if="cname == 'building' && !showDetailBtn"
            class="right_input"
            prop="dong"
            data-key="dongconst"
            label-id="label"
            value-id="value"
            data-type="local"
            placeholder=""
            clearable
          />
          <el-input
            v-else
            v-model="name"
            class="right_input"
            :disabled="disable"
          />
        </el-col>
        <el-col :span="1">
          <el-popover v-show="showDetailBtn" placement="bottom" trigger="click">
            <el-table :data="list" border stripe>
              <el-table-column
                width="80"
                property="blgscd"
                label="建物CD"
              ></el-table-column>
              <el-table-column
                width="120"
                property="blgsnmkj"
                label="建物名"
              ></el-table-column>
            </el-table>
            <div
              slot="reference"
              class="more_box flex_center flex_center_align"
            >
              <div class="inner_box flex_center flex_center_align">
                <svg-icon :icon-class="'sel'"></svg-icon>
              </div>
            </div>
            <!-- <el-button
              slot="reference"
              type="primary"
              size="mini"
              icon="el-icon-more"
            ></el-button> -->
          </el-popover>
        </el-col>
      </el-row>
    </el-form-item>
    <component
      :is="cname"
      :ref="cname"
      v-bind="$attrs"
      @save="handleSureSelect"
    ></component>
  </div>
</template>

<script>
  import mixins from '@/utils/mixForm'
  export default {
    name: 'CommonSelect',
    componentName: 'CommonSelect',
    mixins: [mixins],
    props: {
      gutter: {
        type: Number,
        default: 10,
      },
      single: {
        type: Boolean,
        default: false,
      },
      cname: {
        type: String,
        default: '',
      },
      more: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        code: '',
        name: '',
        showDetailBtn: false,
        list: [],
        disable: false,
      }
    },
    created() {
      this.$on('fieldReset', this.handleFieldReset)
    },
    methods: {
      // 属性をリセットする
      handleFieldReset(initialValue) {
        this.code = initialValue === '' ? null : initialValue
        this.form.model.dong = null
      },
      // 選択を確認する
      handleSureSelect({ data, vc }) {
        console.log(data)
        if (!data) {
          this.msgError(
            this.$t(`validateMessage.${this.$messageCode.W00000034.name}`)
          )
          return
        } else {
          if (data.length > 1) {
            this.list = data
            this.showDetailBtn = true
            this.code = this.name = '<複数>'
            console.log(this.code)
            console.log(this.name)
            this.disable = true
          } else {
            this.showDetailBtn = false
            this.disable = false
            this.name = data[0].bldgcd
            this.code = data[0].blgscd
            // data[0].blgsnmkj
            console.log(data)
          }
          vc.show = false
        }
      },
      // 弾窓を開ける
      openMode() {
        this.$nextTick(() => {
          this.$refs[this.cname].initData()
        })
      },
    },
  }
</script>

<style scoped>
  .elitem {
    width: 100%;
  }
  .elitem /deep/ .el-form-item__content {
    width: 100%;
  }
  .left_input /deep/ .el-input__inner {
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
    padding-right: 35px;
  }
  .leftInput /deep/ .el-input__inner {
    border-top-right-radius: 2.5px;
    border-bottom-right-radius: 2.5px;
  }
  .right_input /deep/ .el-input__inner {
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
    border-left: 0px;
  }
  .col_positon:hover .left_input /deep/ .el-input__inner {
    border-color: #b9daff !important;
  }
</style>
<style lang="scss" scoped>
  .col_positon {
    position: relative;
  }
  .more_box {
    width: 26px;
    height: 26px;
    cursor: pointer;
    position: absolute;
    top: 50%;
    margin-top: -13px;
    right: 3px;
    color: #848484;
    font-size: 14px;
    border-radius: 3px;
    background: #fff;
    .inner_box {
      width: 20px;
      height: 20px;
      background: #0060c2;
      border-radius: 3px;
      color: #fff;
      font-size: 14px;
    }
  }
  .col_positon:hover .more_box {
    background: #ecf5ff;
    color: #0171ee;
  }
</style>
<style lang="scss" scoped>
  .mode ::v-deep {
    .el-dialog__title {
      color: #003350;
    }
  }
  .mode ::v-deep {
    .el-dialog__body {
      padding: 0;
    }
  }
</style>
